import { SET_IS_ONLINE } from './constants';
import { ConnectionState } from './types';

const initialState = {
    isOnline: true
};

export default function (
    state: ConnectionState = initialState,
    action: any
): ConnectionState {
    switch (action.type) {
        case SET_IS_ONLINE:
            return {
                isOnline: action.payload.isOnline
            };
        default:
            return state;
    }
}
